<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $t('nav.project_users_list_title') }}</h4>
          </b-col>
          <b-col md="auto">
            <b-button-group>
              <b-button v-if="!loading && list.actions && list.actions.create" class="mb-3" variant="primary" :to="{ name: 'ProjectUserCreate' }">
                {{ $t('project_user.create_new') }}
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search"/></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="auto" >
            <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
                <b-form-select :options="[2,10,20,50,100,500]" v-model="filters.per_page" />
            </b-form-group>
          </b-col>
          <b-col md="auto" v-if="listPaginator.last_page > 1" >
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
          </b-col>
        </b-row>
        <div v-if="loading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <NoDataView v-if="!tableItems.length"/>
              <b-table v-else class="table-sm text-center" responsive outlined hover head-variant="light"
                  :no-local-sorting=true
                  :sort-by.sync="filters.sort_field"
                  :sort-desc.sync="filters.sort_order"
                  :fields="tableFields"
                  :items="tableItems"
                  >
                <template v-slot:cell(created_at)="{value}">{{ momentf(value) }}</template>
                <template v-slot:cell(updated_at)="{value}">{{ momentf(value) }}</template>
                <template v-slot:cell(options)="row">
                  <div class="flex-container options-center">
                  <router-link v-if="row.item.actions.update" :to="{ name: 'ProjectUserUpdate', params:{ project_id: row.item.project_id, id: row.item.id }}">
                    <a><i class="mx-1 fa fa-edit fa-lg"/></a>
                  </router-link>
                  <Delete v-if="row.item.actions.delete"  :id="row.item.id" @deleted="getData" :deleteFn="()=>deleteFn(row.item.project_id, row.item.id)" />
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator at bottom-->
            <b-col v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import { mapGetters, mapActions, mapState } from 'vuex';
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';

import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      tableFields: [
        { key: 'id', sortable: true, label: this.$t('global.id') },
        { key: 'role', sortable: true, label: this.$t('project_user.role') },
        { key: 'user.full_name', sortable: false, label: this.$t('project_user.user.full_name') },
        { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
        { key: 'updated_at', sortable: true, label: this.$t('global.updated_at') },
        { key: 'options', label: this.$t('global.options') }
      ],
      filters: {
        sort_field: 'id',
        sort_order: true,
        search: '',
        per_page: 20,
      },
      loading: false,
      list: {},
    };
  },
  components: {
    Pagination, NoDataView, Delete
  },
  computed: {
    ...mapState('Auth', ['activeProjectId']),
    ...mapGetters('Auth', ['projects']),
    projectOptions() {
      return this.projects
        .map((i) => ({
          id: i.id,
          label: `${i.id} ${i.name} (${i.role || 'sysadmin'})`,
        }));
    },
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },

    activeProjectId: function () {
      if (this.activeProjectId) this.getData();
    },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.projectUsers.list(this.activeProjectId, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => { this.loading = false; console.log(err); });
    },
    onPageChange(page) {
      page = page || this.page;
      if (page !== this.page) this.$router.push({ name: 'ProjectUsers', params: { page } });
    },
    deleteFn(projectId, id) {
      return Services.projectUsers.delete(projectId, id);
    },
    autoCompleteProject({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const options = this.projects
          .filter((item) => searchQuery === '' || (item.name.search(new RegExp(searchQuery, 'i')) !== -1))
          .map((i) => ({
            id: i.id,
            label: `${i.id} ${i.name} (${i.role || 'sysadmin'})`,
          }));
        callback(null, options);
      }
    },
  }
};
</script>

<style scoped>
</style>
